module.exports = __webpack_public_path__ + "static/media/adpathy.e6db8a0d.png";